import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect, useMemo } from 'react';
import * as THREE from 'three';
import { areRenderPropsValueEqual } from '../_pure/valueEquality.js';
export const GappedConnectorLine = memo(function GappedConnectorLine(props) {
    const resources = useMemo(() => {
        const positions = [];
        const colors = [];
        const activation = props.activation;
        const progress = Math.max(0, Math.min(1, activation?.progress01 ?? 0));
        const reverse = activation?.direction === 'to-from';
        const front = reverse ? 1 - progress : progress;
        for (const [from, to] of props.intervals) {
            const boundaries = front > from && front < to ? [from, front, to] : [from, to];
            for (let index = 1; index < boundaries.length; index++) {
                const left = boundaries[index - 1];
                const right = boundaries[index];
                const active = activation && (reverse ? (left + right) / 2 >= front : (left + right) / 2 <= front);
                const color = new THREE.Color(active ? activation.color : props.color);
                for (const fraction of [left, right]) {
                    positions.push(...props.start.map((value, axis) => value + (props.end[axis] - value) * fraction));
                    colors.push(color.r, color.g, color.b);
                }
            }
        }
        const geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
        geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));
        const material = new THREE.LineBasicMaterial({ vertexColors: true, opacity: props.opacity,
            transparent: props.opacity < 1, depthTest: props.depthTest });
        return { geometry, material };
    }, [props]);
    useEffect(() => () => { resources.geometry.dispose(); resources.material.dispose(); }, [resources]);
    return _jsx("lineSegments", { geometry: resources.geometry, material: resources.material, dispose: null });
}, areRenderPropsValueEqual);
